module.exports = __webpack_public_path__ + "static/img/4.eb52caa8.gif";